import ValidationMessages from '@/views/helpers/validation-messages';
import ValidationCodes from '@/views/helpers/validation-codes';

class ValidationError {
  constructor (payload = {}) {
    this.message = payload.message;
    this.attribute = payload.attribute;
    this.code = payload.code;
  }
}

class ValidationResult {
  constructor () {
    this.errors = {};
  }

  push (validationError) {
    if (validationError == null) return;

    if (!this.errors.hasOwnProperty(validationError.attribute)) {
      this.errors[validationError.attribute] = [];
    }

    this.errors[validationError.attribute].push(validationError);
  }

  errorsFor (attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return this.errors[attribute];
    } else {
      return [];
    }
  }

  messagesFor (attribute) {
    return this.errorsFor(attribute).map(e => e.message);
  }

  deleteAttribute (attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      delete this.errors[attribute];
    }
  }

  isValid () {
    return Object.keys(this.errors).length === 0;
  }
}

const RequiredFieldCheck = function (attribute, value) {
  if (value == null || value === '' || value === []) {
    return new ValidationError({
      attribute: attribute,
      message: ValidationMessages.REQUIRED_FIELD,
      code: ValidationCodes.REQUIRED_FIELD
    });
  }
};

export {
  ValidationError,
  ValidationResult,

  RequiredFieldCheck
};
